export default __webpack_public_path__ + "static/media/face5.ce964104.jpg";